import React, { useContext, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import AppContext from "context/Context";
import classNames from "classnames";
import NavbarTop from "components/navbar/top/NavbarTop";
import NavbarVertical from "components/navbar/vertical/NavbarVertical";
import Footer from "components/pages/landing/Footer";
import UpliftCss from "../../src/components/common/upliftcss.module.css";
import NavbarStandard from "components/pages/landing/NavbarStandard";

const MainLayout = () => {
	const { hash, pathname } = useLocation();
	const isKanban = pathname.includes("kanban");
	// const isChat = pathname.includes('chat');
	const {
		config: { isDark, isRTL },
		setConfig,
	} = useContext(AppContext);
	const {
		config: { isFluid, navbarPosition },
	} = useContext(AppContext);

	useEffect(() => {
		setTimeout(() => {
			if (hash) {
				const id = hash.replace("#", "");
				const element = document.getElementById(id);
				if (element) {
					element.scrollIntoView({ block: "start", behavior: "smooth" });
				}
			}
		}, 0);
	}, []);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	return (
		<div
			className={
				isFluid
					? `container-fluid ${isDark ? UpliftCss.forceBackgrounddark : UpliftCss.forceBackgroundwhite}`
					: `container containerfull ${isDark ? UpliftCss.forceBackgrounddark : UpliftCss.forceBackgroundwhite}`
			}
		>
			<>
				<>
					<div className={classNames("content", { "pb-0": "" })}>
						<NavbarStandard />
						{/*------ Main Routes ------*/}
						<Outlet />
						<Footer />
					</div>
				</>
			</>
		</div>
	);
};

export default MainLayout;
